// extracted by mini-css-extract-plugin
export default {"title-table-line":"_title-table-line_8p+8EF","group-title":"_group-title_5Nh8Wb"};